import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type { EditorPreferencesQuery as EditorPreferencesQueryType } from './__types__/EditorPreferencesQuery';
import { EditorPreferencesQuery } from './EditorPreferencesQuery.graphql';

export const preloadEditorPreferenceQuery = () =>
	query<EditorPreferencesQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: EditorPreferencesQuery,
	});
